type TValidateMessage = Record<string, string>
export const validateMessage: TValidateMessage = {
  min: 'Vui lòng không nhập ít hơn ${min} ký tự',
  max: 'Vui lòng không nhập nhiều hơn ${max} ký tự.',
  passwordValidate: 'Mật khẩu tối thiểu 6 ký tự',
  minDigits: 'Vui lòng không nhập ít hơn ${min} chữ số.',
  maxDigits: 'Vui lòng không nhập nhiều hơn ${max} chữ số.',
  accentAndSpace: 'Mật khẩu không được chứa ký tự có dấu hoặc khoảng trắng.',
  passwordCriteria: 'Mật khẩu tối thiểu 6 ký tự. Bao gồm ít nhất 1 chữ hoa, chữ thường, số và ký tự đặc biệt.',
  usernameSpecialChars: 'Tên đăng nhập không chứa ký tự có dấu hoặc khoảng trắng.',
  notAllowSpace: 'Mật khẩu không được chứa khoảng trắng.'
}

export const resetValidateMessage: TValidateMessage = {
  min: 'Mật khẩu tối thiểu 6 ký tự'
}
